import moment from "moment";

import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import { RAMQVulnerabilityCodeOption } from "@/Common/Models/RAMQ/RAMQVulnerabilityCodeOption";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientProfileEnrollmentComponentProps } from "./IPatientProfileComponentProps";

class PatientProfileEnrollmentCaracteristiqueSanteComponent extends React.Component<IPatientProfileEnrollmentComponentProps, any> {
    private availableCaract: RAMQVulnerabilityCodeOption[];
    constructor(props: IPatientProfileEnrollmentComponentProps) {
        super(props);
        this.availableCaract = RAMQVulnerabilityCodeOption.GetRAMQVulnerabilityCodeOptions();
    }

    public render(): JSX.Element {
        var enrolmentModel = this.props.model;
        var ramqInfo: RAMQInscription;

        if (enrolmentModel) {
            ramqInfo = enrolmentModel.get("RAMQInscription");
        }

        return this.GetCaracteristiqueSanteRender(ramqInfo, enrolmentModel, this.props.IsInAddMode || this.props.IsInEditMode);
    }

    private GetCaracteristiqueSanteRender(ramqInfo: RAMQInscription, model: IPatientEnrollmentModel, showAddEdit: boolean): JSX.Element {
        var caractRender: JSX.Element = null;
        var caracts: JSX.Element[] = null;

        if (showAddEdit) {
            caractRender = (
                <tbody>
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("HealthCharacteristicLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <select onChange={this.onCaractéristiqueSanté1Change.bind(this)} className="form-control myle-control" value={model.get("CaracteristiqueSante1") ? model.get("CaracteristiqueSante1") : ""}>
                                <option value=""> </option>
                                {this.availableCaract.map(p =>
                                    <option key={p.code} value={p.codeString}> {p.name}</option>
                                )}
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("StartDateLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <DateSelector id="datecarac1" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("CaracteristiqueSante1Date")} onSelectOp={LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate1Change} />
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("HealthCharacteristicLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <select onChange={this.onCaractéristiqueSanté2Change.bind(this)} className="form-control myle-control" value={model.get("CaracteristiqueSante2")}>
                                <option value=""> </option>
                                {this.availableCaract.map(p => (
                                    <option key={p.code} value={p.codeString}> {p.name}</option>
                                ))}
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("StartDateLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <DateSelector id="datecarac2" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("CaracteristiqueSante2Date")} onSelectOp={LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate2Change} />
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("HealthCharacteristicLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <select onChange={this.onCaractéristiqueSanté3Change.bind(this)} className="form-control myle-control" value={model.get("CaracteristiqueSante3")}>
                                <option value=""> </option>
                                {this.availableCaract.map(p => (
                                    <option key={p.code} value={p.codeString}> {p.name}</option>
                                ))}
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("StartDateLabel")}</span>
                        </td>
                        <td className="c2 form">
                            <DateSelector id="datecarac3" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("CaracteristiqueSante3Date")} onSelectOp={LocalPatientOperations.Profile.Enrollment_CaracteristiqueSanteDate3Change} />
                        </td>
                    </tr>
                </tbody>
            );
        }
        else if (ramqInfo) {
            if (ramqInfo.CaracteristiqueSantes && ramqInfo.CaracteristiqueSantes.length > 0) {
                caracts = ramqInfo.CaracteristiqueSantes.map((x, idx) => {
                    let code = this.availableCaract.firstOrDefault(c => c.code == x.CodeSante);
                    let caractString = code ? code.name : "";

                    return (
                        <tbody key={"caracSanté" + idx}>
                            <tr>
                                <td className="c1pad form">
                                    <span>{cacheStore.GetString("HealthCharacteristicLabel")}</span>
                                </td>
                                <td className="c2" style={{ width: "400px" }}>
                                    <strong>{MyleHelper.ReplaceEmptyString(caractString)}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td className="c1pad form">
                                    <span>{cacheStore.GetString("StartDateLabel")}</span>
                                </td>
                                <td className="c2" style={{ width: "400px" }}>
                                    <strong>{MyleHelper.ReplaceEmptyString(moment(x.Date).format("YYYY-MM-DD"))}</strong>
                                </td>
                            </tr>
                        </tbody>
                    );
                });
            }

            caractRender = <tbody>{caracts}</tbody>;
        }
        else {
            caractRender = (<div />);
        }

        return caractRender;
    }

    private onCaractéristiqueSanté1Change(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante1Change);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private onCaractéristiqueSanté2Change(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante2Change);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private onCaractéristiqueSanté3Change(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_CaracteristiqueSante3Change);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }
}

export { PatientProfileEnrollmentCaracteristiqueSanteComponent };
